
// src/Components/Manager/ManagerDashboard.jsx
import React from "react";
import { useParams } from "react-router-dom";
import CommunityDashboard from "../Communities/CommunityDashboard";

export default function ManagerDashboard() {
  // The route guard already ensures this ID belongs to the manager
  const { communityId } = useParams();

  // Optionally: you can render some manager-specific header/tools
  return (
    <div className="container mt-3">
      <h4 className="mb-3 d-block">Manager Area • Community <code>{communityId}</code></h4>
      <CommunityDashboard />
    </div>
  );
}